import React, { useState } from 'react';
import { trackFbCustomEvent } from '../utils/fbPixel';
const faqs = [{
  question: '¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Apenas se confirma el pago recibís el acceso por mail. Todo es digital y lo podés abrir desde celular, tablet o computadora.'
}, {
  question: '¿Sirve para cualquier año de la carrera?',
  answer: 'Sí. Los 6 tomos cubren toda la carrera, desde materias base hasta práctica pre-profesional. Lo usás según lo que estés cursando ahora.'
}, {
  question: '¿Los 6 bonos están incluidos?',
  answer: 'Sí. Los 6 bonos están incluidos tanto en el MegaPack Base como en la versión más completa.'
}, {
  question: '¿Qué cambia en la versión más completa?',
  answer: 'Suma un kit editable de organización académica con planner, calendario, seguimiento de materias, parciales y recursos para estudiar con más orden.'
}, {
  question: '¿Sirve para parciales y finales difíciles?',
  answer: 'Sí. Tenés resúmenes, protocolos, casos clínicos, checklists y material pensado para estudiar más rápido y con más claridad.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Tenés 7 días para revisarlo. Si no era lo que esperabas, te devolvemos el 100%.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(239,246,255) 42%, rgb(219,234,254) 100%)'
  }} data-id="element-142">
      <div className="mx-auto max-w-4xl" data-id="element-143">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-144">
          Preguntas <span className="text-blue-700" data-id="element-145">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-146">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-147">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(59,130,246,0.5)' : '1px solid rgba(59,130,246,0.15)'
          }} data-id="element-148">
                {/* Question */}
                <button onClick={() => {
              const newIndex = isOpen ? null : i;
              setOpenIndex(newIndex);
              if (newIndex !== null) {
                trackFbCustomEvent('FAQOpen', {
                  question: faq.question,
                  question_index: i + 1,
                  content_category: 'Kinesiología Carrera Resuelta'
                });
              }
            }} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-149">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#1d4ed8' : '#111827'
              }} data-id="element-150">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#1d4ed8',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-151">
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(59,130,246,0.1)'
            }} data-id="element-152">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-153">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}